/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCategory.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/category";

export class AutogenModelCategory<RowType extends ModelRow> extends Endpoint<RowType, RowCategoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCategory extends ModelRow<RowCategoryFields> {
	constructor(values?: Partial<RowCategoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCategoryFields {
	carrier: string;
	company_id: string;
	customer: string;
	descr: string;
	id: string;
	location: string;
	veh_mnt: string;
	vendor: string;
}

